export const GET_BANK_ACCOUNT = 'getBankAccount'
export const GET_PRODUCT_LIST = 'getProductList'
export const GET_PRODUCT = 'getProduct'
export const GET_PRICE_LIST = 'getPriceList'
export const GET_ORDER = 'getOrder'
export const GET_BITCASH_PREPARE = 'getBitcashPrepare'
export const GET_NETRIDECASH_PREPARE = 'getNetridecashPrepare'
export const GET_BANK_ANOTHERLANE_PREPARE = 'getBankAnotherlanePrepare'
export const GET_ORDER_COMPLETE = 'getOrderComplete'
export const GET_BANK_ANOTHERLANE_CONFIRM = 'getBankAnotherlaneConfirm'
